import React from 'react';

import './Invalid.component.css';

export default class Invalid extends React.Component {
    render() {
        return (
            <div className="invalid-container">
                We encountered a problem.  Please use the table in email reply.
            </div>
        );
    }
}